import { gql } from "@apollo/client";

export const ACC_COMPANY_CHANNELS = gql`
  query Acc_getCompanyChannels($companyUuid: String!) {
    acc_getCompanyChannels(companyUUID: $companyUuid) {
      name
      active
      info {
        id
        data
        description
        url
      }
    }
  }
`;
export const ACC_GET_DNS_HOST_LINK = gql`
  query Acc_getDnsHostLink($companyUuid: String!) {
    acc_getDnsHostLink(companyUUID: $companyUuid) {
      cName
      subDomain
    }
  }
`;

export const ACC_GET_COMPANY_EXT_DATA = gql`
  query Acc_getCompanyExtData($companyUuid: String!) {
    acc_getCompanyExtData(companyUUID: $companyUuid) {
      name
      title
      styles {
        favicon
        logoMain
        logoSecond
      }
      styleUrls {
        favicon {
          fileID
          url
          method
          xAmxTagging
        }
        logoMain {
          fileID
          url
          method
          xAmxTagging
        }
        logoSecond {
          fileID
          url
          method
          xAmxTagging
        }
      }
    }
  }
`;

export const ACC_PUT_CACHE = gql`
  mutation Acc_putCache($input: CacheInput!) {
    acc_putCache(input: $input) {
      code
      message
      success
    }
  }
`;

export const ACC_GET_CACHE = gql`
  query Acc_getCache($workspace: String, $keys: [String!]) {
    acc_getCache(workspace: $workspace, keys: $keys) {
      key
      value
    }
  }
`;
